



















































































































import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import AsociacionGrid from '@/reusable/Grid/AsociacionGrid.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { AxiosVue } from '@/AxiosVue';
import { Snotify } from '@/snotify/Snotify';
import { ServicioProxy, Accion } from '@/config/enums';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  GridReadyEvent,
  ICellRendererParams,
  SelectionChangedEvent,
  ColDef,
  ColGroupDef,
} from 'ag-grid-community';

@Component({
  components: {
    ModalMantenedor,
    AsociacionGrid,
  },
})
export default class Asignacion extends Vue {
  readonly funcionalidad: Funcionalidades = Funcionalidades.asignarmandante;
  columnDefs: any[] = [];
  readonly gridOptions: GridOptions;
  serverSide: any;
  columnApi: ColumnApi;
  axios: AxiosVue = new AxiosVue(ServicioProxy.MS);
  readonly loadingService = new LoadingService();
  rowData: any[] = [];
  isMandanteFound: boolean = false;
  readonly $snotify: Snotify;
  mostrarBotonAsignar: boolean = false;
  enrichedGridOptions: GridOptions = null;
  filtroKey: number = null;
  searchPatente: string = '';
  plataformaKey: number = null;
  rutError: string[] = [];
  bodyDesasociar: any[] = [];
  rutMandante: string = '';
  nombreError: string[] = [];
  nombreMandante: string = '';
  mostrarCampoNombre: boolean = false;
  disabled: boolean = true;
  vehiculosSeleccionados: any[] = [];
  gridApi: GridApi;
  rutRule = (v: string) =>
    v
      ? v.match(/^\d{1,2}\d{3}\d{3}-[\dkK]$/) || 'Formato de RUT incorrecto'
      : true;

  get isRutValid(): boolean {
    return this.rutMandante.match(/^\d{1,2}\d{3}\d{3}-[\dkK]$/) !== null;
  }
  constructor() {
    super();
    console.log('User ID:', this.userID);
    console.log('Cliente Defecto:', this.clienteDefecto);
    this.gridOptions = {
      onGridReady: this.onGridReady,
      onSelectionChanged: this.handleSelectionChanged,
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      paginationAutoPageSize: false,
      serverSideDatasource: this.serverSide,
      suppressRowClickSelection: true,
      rowModelType: 'clientSide',
      columnDefs: [
        {
          headerName: 'Rut Mandante',
          field: 'rut_mandante',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Nombre Mandante',
          field: 'nombre_mandante',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Código Vehículo',
          field: 'cod_vehiculo',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Flota',
          field: '__nom_flota',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Patente',
          field: 'patente_vehiculo',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Código Referencia',
          field: '__refvehiculo',
          filter: 'agTextColumnFilter',
        },
      ],
    };
  }
  cargodatos() {
    const self = this;
    self.loadingService.showLoading();
    self.axios.http
      .post('Metabase/PostgenericA/asignar_mandante/getVehiculosAsignados', {
        clienteid: this.clienteDefecto,
      })
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA === '1') {
          self.rowData = response.data.data;
          self.gridApi.setRowData(self.rowData);
          self.gridApi.hideOverlay();
        } else {
          self.rowData = [];
          self.gridApi.setRowData([]);
          self.gridApi.showNoRowsOverlay();
        }
      })
      .catch((error: any) => {
        console.log('Error en la petición:', error);
        console.log(error);
        self.rowData = [];
        self.gridApi.showNoRowsOverlay();
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }

  cancelar() {
    this.rutMandante = '';
    this.nombreMandante = '';
    this.mostrarCampoNombre = false;
    this.mostrarBotonAsignar = false;
    this.rutError = [];
    this.nombreError = [];
    this.isMandanteFound = false;
  }

  async onGridReady(params: GridReadyEvent) {
    this.loadingService.showLoading();
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.handleSelectionChanged({ api: this.gridApi } as SelectionChangedEvent);
    this.cargodatos();
  }

  buscarmandante() {
    const self = this;
    const rut = this.rutMandante;

    if (!rut) {
      this.rutError = ['Por favor, ingrese un RUT.'];
      return;
    } else if (!this.validarRut(rut)) {
      this.rutError = ['Formato de RUT incorrecto.'];
      return;
    } else {
      this.rutError = [];
    }

    self.loadingService.showLoading();
    self.axios.http
      .post('Metabase/PostgenericA/asignar_mandante/buscarMandante', { rut })
      .then((response: any) => {
        console.log('Response data:', response.data);
        if (
          response.data.CODIGO_RESPUESTA === '1' &&
          response.data.data.length > 0
        ) {
          const mandanteData = response.data.data[0];
          if (mandanteData.STATUS === 'SIN_DATA') {
            self.rutMandante = response.data.data[0].rut_ingresado;
            self.nombreMandante = '';
            self.rutError = ['RUT no encontrado, agregue nuevo mandante'];
            self.nombreError = ['Ingrese nombre de mandante'];
            self.isMandanteFound = false;
          } else {
            this.rutMandante = this.formatearRut(
              response.data.data[0].rut_mandante
            );
            self.nombreMandante = response.data.data[0].nombre_mandante;
            self.rutError = [];
            self.nombreError = [];
            self.isMandanteFound = true;
          }
        } else {
          self.rutMandante = '';
          self.nombreMandante = '';
          self.rutError = ['RUT no encontrado, agregue nuevo mandante'];
          self.nombreError = ['Ingrese nombre de mandante'];
          self.isMandanteFound = false;
        }
        self.mostrarCampoNombre = true;
        self.mostrarBotonAsignar = true;
      })
      .catch((error: any) => {
        console.log('Error en la petición:', error);
        self.rutMandante = '';
        self.nombreMandante = '';
        self.rutError = ['RUT no encontrado, agregue nuevo mandante'];
        self.nombreError = ['Ingrese nombre de mandante'];
        self.isMandanteFound = false;
        self.mostrarCampoNombre = true;
        self.mostrarBotonAsignar = true;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }
  resetRut() {
    this.rutMandante = '';
    this.clearRutError();
  }
  limpiarCampos() {
    this.resetRut();
    this.rutMandante = '';
    this.nombreMandante = '';
    this.mostrarCampoNombre = false;
    this.mostrarBotonAsignar = false;
    this.vehiculosSeleccionados = [];
    this.gridApi.deselectAll();
    this.rutError = [];
    this.nombreError = [];
    this.isMandanteFound = false;
  }

  validarRut(rut: string): boolean {
    // Eliminar puntos y guión
    let cleanedRut = rut.replace(/\./g, '').replace(/-/g, '');
    // Dividir en cuerpo y dígito verificador
    let body = cleanedRut.slice(0, -1);
    let verifier = cleanedRut.slice(-1).toUpperCase();

    // Verificar longitud y que el cuerpo sean solo números
    if (body.length < 7 || !/^\d+$/.test(body)) {
      return false;
    }

    // Calcular dígito verificador
    let sum = 0;
    let multiplier = 2;
    for (let i = body.length - 1; i >= 0; i--) {
      sum += parseInt(body[i]) * multiplier;
      multiplier = multiplier < 7 ? multiplier + 1 : 2;
    }
    let calculatedVerifier = 11 - (sum % 11);
    let verifierString =
      calculatedVerifier === 11
        ? '0'
        : calculatedVerifier === 10
        ? 'K'
        : calculatedVerifier.toString();

    // Comparar con el dígito verificador ingresado
    return verifier === verifierString;
  }
  clearRutError() {
    this.rutError = [];
  }
  @Watch('rutError')
  onRutErrorChange(newVal: string[]) {
    if (newVal.includes('RUT no encontrado, ingrese RUT manualmente')) {
      this.$forceUpdate(); // Validar el campo para mostrar el mensaje de error
    }
  }

  @Watch('nombreError')
  onNombreErrorChange(newVal: string[]) {
    if (newVal.includes('Ingrese nombre de mandante')) {
      this.$forceUpdate(); // Forzar la actualización del componente para mostrar el mensaje de error
    }
  }
  filtrarPorPatente() {
    const searchText = this.searchPatente
      ? this.searchPatente.toLowerCase().trim()
      : '';

    // Si no hay texto de búsqueda, muestra todas las filas originales
    if (!searchText) {
      this.gridApi.setRowData(this.rowData);
      this.gridApi.onFilterChanged();
      return;
    }

    // Filtra las filas que coincidan exactamente con el texto de búsqueda en alguna columna
    const filteredRows = this.rowData.filter(row => {
      return Object.values(row).some(value => {
        return String(value)
          .toLowerCase()
          .includes(searchText);
      });
    });

    // Actualiza las filas en la grilla con los resultados filtrados
    this.gridApi.setRowData(filteredRows);

    // Fuerza la actualización de la grilla después de aplicar el filtro
    this.gridApi.onFilterChanged();
  }

  //user = localStorage.getItem('user');
  // userId = JSON.parse(user.replace(/'/g, '"')).id;
  userID = JSON.parse(localStorage.getItem('user')).id;
  clienteDefecto = localStorage.getItem('clienteDefecto');
  asignarMandante() {
    if (this.vehiculosSeleccionados.length === 0) {
      this.$snotify.error('Debe seleccionar al menos un vehículo');
      return;
    }

    if (!this.validarRut(this.rutMandante)) {
      this.rutError = ['Formato de RUT incorrecto.'];
      return;
    }
    const payload = {
      rut: this.rutMandante,
      nombre: this.nombreMandante,
      cliente_id: this.clienteDefecto,
      vehiculos: this.vehiculosSeleccionados.map(codigo => Number(codigo)),
      usuario_id: this.userID,
    };
    console.log('Payload:', JSON.stringify(payload, null, 2));
    this.axios.http
      .post('Metabase/PostgenericA/asignar_mandante/guardarAsignacion', payload)
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.$snotify.success('Mandante asignado con exito');
          this.gridApi.deselectAll();
          this.limpiarCampos();
          this.cargodatos();
          this.limpiarCampos();
        } else {
          this.$snotify.success('Error al asignar mandante');
        }
      })
      .catch((error: any) => {
        console.error('Error al realizar la petición:', error);
      });
  }

  handleSelectionChanged(event: SelectionChangedEvent) {
    if (!event.api) {
      console.error('El objeto "event" no tiene la propiedad "api".', event);
      return;
    }
    const Vehiculos = event.api.getSelectedRows();
    this.vehiculosSeleccionados = Vehiculos.map(
      (vehiculo: any) => vehiculo.cod_vehiculo
    );
    console.log(
      'Códigos de vehículos seleccionados:',
      this.vehiculosSeleccionados
    );
  }
  formatearRut(rut: string): string {
    // Eliminar cualquier guion existente primero
    let cleanedRut = rut.replace(/-/g, '');
    const body = cleanedRut.slice(0, -1);
    const verifier = cleanedRut.slice(-1);
    return `${body}-${verifier}`;
  }

  clearNombreError() {
    this.nombreError = [];
  }
}
